export default __webpack_public_path__ + "static/IllustrationSmartMirror-ace849f15f0070bb97694879cc844168.svg";